export const navigator = () => window.navigator;
